/* do not edit. this file is generated by npm run lib:icons and constantly overwritten */
import React from 'react'
/**
 * @deprecated Use icons from `@chilipiper/icons/figma-generated/src/icon` or
 *   `@chilipiper/icons/figma-generated/src/logo` instead
 */
export const SvgSandClock = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={16}
    viewBox='0 0 20 22'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M3.7 3.00001C3.7 1.72976 4.72974 0.700012 6 0.700012H14C15.2703 0.700012 16.3 1.72976 16.3 3.00001V4.11626C16.3 6.33388 15.2919 8.43127 13.5603 9.81661L12.081 11L13.5603 12.1834C15.2919 13.5688 16.3 15.6661 16.3 17.8838V19C16.3 20.2703 15.2703 21.3 14 21.3H6C4.72974 21.3 3.7 20.2703 3.7 19V18.4853C3.7 16.5492 4.4691 14.6924 5.83812 13.3234L6.08076 13.0808C6.58844 12.5731 7.41155 12.5731 7.91924 13.0808C8.42692 13.5885 8.42692 14.4116 7.91924 14.9193L7.67659 15.1619C6.79517 16.0433 6.3 17.2388 6.3 18.4853V18.7H13.7V17.8838C13.7 16.456 13.051 15.1056 11.9361 14.2137L6.43972 9.81661C4.70805 8.43127 3.7 6.33388 3.7 4.11626V3.00001ZM10 9.3352L11.9361 7.78635C13.051 6.89442 13.7 5.54405 13.7 4.11626V3.30001H6.3V4.11626C6.3 5.54405 6.94902 6.89442 8.06393 7.78635L10 9.3352Z'
      fill='currentColor'
    />
  </svg>
)
export default SvgSandClock
